export const pageview = (url) => {
  window.gtag('config', 'G-WHBENRX9PN', {
    page_path: url,
  });
};
